<form class="layout-form" [formGroup]="contactForm" (ngSubmit)="onSubmit()">
  <div class="component-content">
    <div class="form-header" [ngClass]="{ 'shadow-top': shadowScroll.showShadowTop }">
      <p>Datos de contacto y Entrega</p>
      <span> Ingrese sus datos de contacto y recepción de bebida </span>
    </div>
    <div class="scroll-display" (scroll)="onScroll($event)">
      <div class="form-select-content">
        <app-file-upload-component
          *ngFor="let file of files; let i = index"
          [labelText]="file.label"
          [isImg]="file.isImg"
          [extensions]="file.extensions"
          [documentId]="file.documentId"
          [formControlName]="'uploadFile' + i"
          [maxSizeFile]="file.size"
          [id]="'file' + i"
          [required]="true"
          [submitted]="submitted"
        ></app-file-upload-component>
      </div>

      <div class="form-select-content">
        <app-text-input
          data-testid="input-email"
          [labelText]="'Email del Comercio o Titular'"
          [type]="'email'"
          [subText]="'Ingrese una dirección válida'"
          [required]="true"
          formControlName="email"
          [submitted]="submitted"
        ></app-text-input>
      </div>

      <div class="form-select-content">
        <label class="input-label">Celular del Comercio o Titular</label>
        <div class="phone-inputs-container">
          <app-text-input
            class="number"
            data-testid="numero-cel"
            [labelText]="'Numero'"
            [type]="'telephone-number'"
            [subText]="'Incluir código de país y área'"
            [required]="true"
            formControlName="telephoneNumber"
            [submitted]="submitted"
            [placeholder]="'123456'"
          ></app-text-input>
        </div>
        <div class="warning-label" *ngIf="submitted && validationLenthTelephone('principal')">
          Longitud del número celular inválido (10 dígitos)
        </div>
      </div>

      <div class="form-select-content">
        <label class="input-label">Telefono del Comercio o Titular (opcional)</label>
        <div class="phone-inputs-container">
          <app-text-input
            data-testid="numero-cel-secundario"
            class="number"
            [labelText]="'Numero'"
            [type]="'telephone-number-optional'"
            [subText]="'Incluir código de país y área'"
            formControlName="secondaryTelephoneNumber"
            [submitted]="submitted"
            [placeholder]="'123456'"
          ></app-text-input>
        </div>
        <div class="warning-label" *ngIf="submitted && validationLenthTelephone('optional')">
          Longitud del número de comercio inválido (10 dígitos)
        </div>
      </div>

      <div class="form-select-content">
        <label class="input-label">Franja horaria de entrega por la mañana</label>
        <div class="time-picker--content">
            <app-time-picker [attr.data-testid]="'picker-franja-mañana-inicio'" [timeTo]="timeA.end" [timeFrom]="timeA.start" [sumeTime]="sumeTime" [submitted]="submitted" formControlName="timeAStart"></app-time-picker>
            <span class="time-picker--separator">-</span>
            <app-time-picker [attr.data-testid]="'picker-franja-mañana-final'"  [timeTo]="timeA.end" [timeFrom]="timeA.start" [sumeTime]="sumeTime" [submitted]="submitted" formControlName="timeAEnd"></app-time-picker>
        </div>
        <div class="warning-label" *ngIf="!validationPicker(this.contactForm.controls['timeAStart'].value, this.contactForm.controls['timeAEnd'].value,
        this.contactForm.controls['timeAStart'].dirty, this.contactForm.controls['timeAEnd'].dirty )">
            Horario inválido
        </div>
    </div>
    <div class="form-select-content">
        <label class="input-label">Franja horaria de entrega por la tarde</label>
        <div class="time-picker--content">
            <app-time-picker [attr.data-testid]="'picker-franja-tarde-inicio'" [sumeTime]="sumeTime" [timeTo]="timeB.end" [timeFrom]="timeB.start" [submitted]="submitted" formControlName="timeBStart"></app-time-picker>
            <span class="time-picker--separator">-</span>
            <app-time-picker [attr.data-testid]="'picker-franja-tarde-final'" [sumeTime]="sumeTime" [timeTo]="timeB.end" [timeFrom]="timeB.start" [submitted]="submitted" formControlName="timeBEnd"></app-time-picker>
        </div>
        <div class="warning-label" *ngIf="!validationPicker(this.contactForm.controls['timeBStart'].value, this.contactForm.controls['timeBEnd'].value,
        this.contactForm.controls['timeBStart'].dirty, this.contactForm.controls['timeBEnd'].dirty )">
            Horario inválido
        </div>
        <div class="warning-label" *ngIf="submitted && sumeTime < 4">
            La suma de la franja horaria A y B debe ser mayor a 4 horas.
        </div>
    </div>
    </div>
  </div>
  <div class="form-navigation" [ngClass]="{ 'shadow-bottom': shadowScroll.showShadowBottom }">
    <app-navigation [currentStep]="6" [countSteppers]="7"></app-navigation>
  </div>
  <div class="button-container">
    <button mat-raised-button class="back-button" type="button" (click)="back()">Anterior</button>
    <button mat-raised-button class="next-button next-button__60" type="submit">Siguiente</button>
  </div>
</form>
